import React from "react";
import * as Yup from "yup";
import { TranslatedText } from "../../../helpers/helpers";

export const schemaUserLogin = Yup.object().shape({
  username: Yup.string().required(
    <TranslatedText i18nKey="errors.login.username.required" />
  ),
  password: Yup.string().required(
    <TranslatedText i18nKey="errors.login.password.required" />
  ),
  recaptcha: Yup.string().required(
    <TranslatedText i18nKey="common.required.input" />
  ),
});

export const initialValuesUserLogin = {
  username: "",
  password: "",
  rememberMe: false,
  recaptcha: "",
};
